import { render } from "./CourseLevel.vue?vue&type=template&id=9139cb2a&scoped=true"
import script from "./CourseLevel.vue?vue&type=script&lang=js"
export * from "./CourseLevel.vue?vue&type=script&lang=js"

import "./CourseLevel.vue?vue&type=style&index=0&id=9139cb2a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9139cb2a"

export default script